import React from "react"
import PropTypes from "prop-types"
import { List } from "immutable"
import { connect } from "react-redux"
import { Layout, Modal, Input, message } from "antd"
import HeaderView from "./HeaderView"
import ContentView from "./ContentView"
import * as actions from "../redux/actions"

const { Content } = Layout
const { TextArea } = Input

class AppRoot extends React.Component {
	static propTypes = {
		soModalVisable: PropTypes.bool,
		soModalEditing: PropTypes.bool,
		soModalLoading: PropTypes.bool,
		data: PropTypes.objectOf(List),
		regNoInputValue: PropTypes.string,
		soNoTextAreaValue: PropTypes.string,
		soModalMessage: PropTypes.string,
		contModalVisable: PropTypes.bool,
		contModalList: PropTypes.object,
		updateContentHeight: PropTypes.func,
		loadData: PropTypes.func,
		hideSoModal: PropTypes.func,
		updateRegNoInput: PropTypes.func,
		updateSoNoTextArea: PropTypes.func,
		addSoData: PropTypes.func,
		editSoData: PropTypes.func,
		hideContModal: PropTypes.func,
	}

	componentWillMount() {
		this.props.loadData()
	}


	componentDidMount() {
		this.props.updateContentHeight(this.contentRef.clientHeight)
	}

	render() {
		const contModalList = this.props.contModalList.toJS()
		return (
			<Layout className="layout" style={{
				display: "flex",
				flex: 1,
				flexDirection: "column",
				height: "100vh",
			}}>
				<Content style={{
					display: "flex",
					flex: 1,
					padding: 24,
					zIndex: 1,
				}}>
					<div
						style={{
							display: "flex",
							flex: 1,
							flexDirection: "column",
							padding: 24,
							background: "rgba(255, 255, 255, 1)",
							borderTopLeftRadius: 4,
							borderBottomLeftRadius: 4,
							borderBottomRightRadius: 4,
							borderTopRightRadius: 4,
						}}
						ref={(ref) => {
							this.contentRef = ref
						}}
					>
						<HeaderView />
						<ContentView />
					</div>
				</Content>
				<Modal
					title={"貨櫃號碼"}
					visible={this.props.contModalVisable}
					maskClosable={true}
					okText={"複製"}
					onOk={() => {
						const textarea = document.createElement("textarea")
						textarea.value = contModalList.join("\n")
						document.body.appendChild(textarea)
						textarea.select()
						document.execCommand("copy")
						document.body.removeChild(textarea)
						message.success(`${contModalList.length} 筆貨櫃號碼已複製`)
					}}
					cancelText={"取消"}
					onCancel={this.props.hideContModal}
				>
					<TextArea
						autosize={{ minRows: 6, maxRows: 18 }}
						value={contModalList.join("\n")}
						onChange={() => { }}
					/>
				</Modal>
				<Modal
					title={this.props.soModalEditing ? "編輯查詢單號" : "新增查詢單號"}
					okText={this.props.soModalEditing ? "編輯" : "新增"}
					cancelText={"取消"}
					closable={false}
					maskClosable={false}
					visible={this.props.soModalVisable}
					confirmLoading={this.props.soModalLoading}
					onOk={() => {
						if (this.props.soModalEditing) {
							this.props.editSoData()
						} else {
							this.props.addSoData()
						}
					}}
					onCancel={() => {
						if (!this.props.soModalLoading) {
							this.props.hideSoModal()
						}
					}}
				>
					海關通關號碼（原船隻掛號）
					<Input
						placeholder={"915295"}
						value={this.props.regNoInputValue}
						onChange={(event) => {
							this.props.updateRegNoInput(event.target.value)
						}}
					/>
					<br />
					<br />
					裝貨單號碼（S/O No.）
					<TextArea
						autosize={{ minRows: 6, maxRows: 18 }}
						placeholder={"0001\n0002\n0123\n0124\n0125\n..."}
						value={this.props.soNoTextAreaValue}
						onChange={(event) => {
							this.props.updateSoNoTextArea(event.target.value)
						}}
					/>
					<p style={{ color: "red" }}><br />{this.props.soModalMessage}</p>
				</Modal>
			</Layout>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		soModalVisable: state.getIn(["main", "soModalVisable"]),
		soModalEditing: state.getIn(["main", "soModalEditing"]),
		soModalLoading: state.getIn(["main", "soModalLoading"]),
		data: state.getIn(["main", "data"]),
		regNoInputValue: state.getIn(["main", "regNoInputValue"]),
		soNoTextAreaValue: state.getIn(["main", "soNoTextAreaValue"]),
		soModalMessage: state.getIn(["main", "soModalMessage"]),
		contModalVisable: state.getIn(["main", "contModalVisable"]),
		contModalList: state.getIn(["main", "contModalList"]),
	}
}

const mapDispatchToProps = {
	updateContentHeight: actions.updateContentHeight,
	loadData: actions.loadData,
	hideSoModal: actions.hideSoModal,
	updateRegNoInput: actions.updateRegNoInput,
	updateSoNoTextArea: actions.updateSoNoTextArea,
	addSoData: actions.addSoData,
	editSoData: actions.editSoData,
	hideContModal: actions.hideContModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppRoot)



// WEBPACK FOOTER //
// ./src/conponents/AppRoot.js